class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.targetDate = new Date(this.dataset.targetDate);
    this.message = this.dataset.message;
    this.timeLeftMessage = this.dataset.timeLeftMessage;
    this.countdownType = this.dataset.countdownType;
    this.bannerElement = this;
    this.countdownElement = this.querySelector('[data-countdown-timer]');
    this.countdownGridDay = this.querySelector('[data-countdown-grid-day]');
    this.countdownGridHour = this.querySelector('[data-countdown-grid-hour]');
    this.countdownGridMinute = this.querySelector('[data-countdown-grid-minute]');
    this.countdownGridSecond = this.querySelector('[data-countdown-grid-second]');
    this.interval = null;
  }

  connectedCallback() {
    // Start the countdown immediately
    this.updateCountdown();

    // Update every second
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  disconnectedCallback() {
    // Clean up the interval when the element is removed
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  updateCountdown() {
    const now = new Date();
    const timeRemaining = this.targetDate - now;

    // Check if countdown has expired
    if (timeRemaining <= 0) {
      if (this.countdownType === 'daily') {
        // For daily countdowns, recalculate the next reset time
        this.calculateNextDailyReset();
      } else {
        // For promotion countdowns, hide the banner
        this.bannerElement.classList.add('hidden');
        clearInterval(this.interval);
        return;
      }
    }

    // Calculate time units
    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    // Format the countdown display
    let countdownText = '';

    if (days > 0) {
      countdownText += `${days}d `;
    }

    countdownText += `${this.padZero(hours)}h ${this.padZero(minutes)}m ${this.padZero(seconds)}s`;

    if (this.countdownGridDay) {
      this.countdownGridDay.textContent = days;
      this.countdownGridHour.textContent = hours;
      this.countdownGridMinute.textContent = minutes;
      this.countdownGridSecond.textContent = seconds;
      return;
    }

    this.countdownElement.textContent = countdownText;
  }

  calculateNextDailyReset() {
    // Get the reset hour and minute from the data attributes
    const resetHour = parseInt(this.dataset.resetHour) || 0;
    const resetMinute = parseInt(this.dataset.resetMinute) || 0;

    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate(), resetHour, resetMinute, 0);

    // If the reset time has already passed today, set it for tomorrow
    if (now >= today) {
      today.setDate(today.getDate() + 1);
    }

    this.targetDate = today;
  }

  padZero(number) {
    return number < 10 ? `0${number}` : number;
  }
}

customElements.define('countdown-timer', CountdownTimer);
